import { createAction, handleActions } from 'redux-actions'

const setSortBy = createAction('SCREENS/SUB_PROJECT/SUB_PROJECTS/SET_SORT_BY')
const resetSortBy = createAction('SCREENS/SUB_PROJECT/SUB_PROJECTS/RESET_SORT_BY')

const defaultState = null

const reducer = handleActions(
  {
    [setSortBy]: (state, { payload }) => payload,
    [resetSortBy]: () => defaultState,
  },
  defaultState,
)

export { setSortBy, resetSortBy, reducer }
